<bp-register-authenticator-app-form
	class="h-100"
	submitButtonText="Reset Authenticator"
	submitButtonGtagEventName="reset_authenticator_click"
	[userEmail]="(identityFacade.incompleteIdentity$ | async)?.email"
	[authenticatorKey]="identityFacade.authenticatorKey$ | async"
	[pending]="introFacade.pending$ | async"
	[error]="introFacade.error$ | async"
	(submitted)="identityFacade.resetAuthenticatorApp($event)"
	(login)="introFacade.gotoLoginPage()"
>
</bp-register-authenticator-app-form>
